import { __awaiter, __generator } from "tslib";
import { fetchSFCCSetting } from '../../api';
import { getWebStoreApiClient } from '../../auth/web-store-api/client/client';
import { getAuthBearerValue } from '../../common/utilities';
/**
 * @internal
 */
export var getSFCCRequestHeaders = function () { return __awaiter(void 0, void 0, void 0, function () {
    var requestHeaders, sfccClientId, _a, _b, _c, _d;
    var _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                requestHeaders = new Headers();
                return [4 /*yield*/, fetchSFCCSetting()];
            case 1:
                sfccClientId = (_e = (_f.sent())) === null || _e === void 0 ? void 0 : _e.shopApiClientId;
                if (sfccClientId) {
                    requestHeaders.set("x-dw-client-id" /* ClientId */, sfccClientId);
                }
                else {
                    console.warn("SFCC Client ID is not set");
                }
                _b = (_a = requestHeaders).set;
                _c = ["Authorization" /* Authorization */];
                _d = getAuthBearerValue;
                return [4 /*yield*/, getWebStoreApiClient().onTokenAcquired];
            case 2:
                _b.apply(_a, _c.concat([_d.apply(void 0, [_f.sent()])]));
                return [2 /*return*/, { headers: requestHeaders, credentials: 'include' }];
        }
    });
}); };
